<template>
  <div v-if="isModalOpen">
    <!-- Modal -->
    <transition name="fade">
      <div class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-center justify-center min-h-screen px-4">
          <div class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full">
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div class="sm:flex sm:items-start">
                <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                  <font-awesome-icon icon="exclamation-circle" class="h-6 w-6 text-blue-600" />
                </div>
                <div class="text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <h3 class="text-lg leading-6 font-medium text-gray-900">
                    {{ titleComputed }}
                  </h3>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500" v-html="messageComputed"></p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isComment" class="px-4 sm:px-6">
              <form id="form" novalidate class="position-relative" @submit.prevent>
                <LmTextArea
                  v-if="type === 'textarea'"
                  id="comment"
                  v-model="form.comment"
                  :label="$t(labelComment)"
                  :v="isCommentValidationRequired ? customValidation : { value: false }"
                  ref="lmTextArea"
                />
                <input
                  v-if="type === 'token'"
                  autocomplete="off"
                  class="my-5 token"
                  :v="isCommentValidationRequired ? customValidation : { value: false }"
                  ref="lmTextArea"
                  v-model.trim="form.comment"
                  maxlength="6"
                />
              </form>
            </div>
            <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <button @click="ok" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm">
                {{ okButtonTitle }}
              </button>
              <button @click="cancel" class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm">
                {{ cancelButtonTitle }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import LmTextArea from '@/components/form/elements/LmTextArea.vue'

export default {
  components: {
    LmTextArea
  },
  data () {
    return {
      isModalOpen: false,
      id: null,
      messageData: '',
      titleData: '',
      isComment: false,
      isCommentValidationRequired: false,
      mustValidate: false,
      labelComment: '',
      initialForm: {},
      type: 'textarea',
      form: {
        comment: '',
        id: null
      },
      okButtonTitle: this.$t('Ok'),
      cancelButtonTitle: this.$t('cancel')
    }
  },
  computed: {
    customValidation () {
      return {
        required: this.isCommentValidationRequired,
        $error: !this.form.comment && this.mustValidate
      }
    },
    messageComputed () {
      return this.messageData || this.message
    },
    titleComputed () {
      return this.titleData || this.title
    }
  },
  props: {
    message: {
      type: String,
      default () {
        return this.$t('are_you_sure')
      }
    },
    title: {
      type: String,
      default () {
        return this.$t('are_you_sure')
      }
    },
    okTitle: {
      type: String,
      default: null
    },
    cancelTitle: {
      type: String,
      default: null
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openModal () {
      this.isModalOpen = true
    },
    closeModal () {
      this.isModalOpen = false
    },
    lmShow () {
      this.openModal()
      return new Promise((resolve, reject) => {
        this.$on('ok', (data) => {
          if (this.isComment) {
            resolve(data?.comment || 'ok')
          } else {
            resolve('ok')
          }
        })
        this.$on('cancel', () => {
          // eslint-disable-next-line
          reject('cancel')
        })
      })
    },
    setMessageProps (message) {
      this.messageData = message
    },
    setTitleProps (title) {
      this.titleData = title
    },
    setIsCommentProps (isComment, isCommentValidationRequired, labelComment, type = 'textarea') {
      if (isComment) {
        this.type = type
        this.isComment = isComment
        this.labelComment = labelComment
        this.isCommentValidationRequired = isCommentValidationRequired
      }
    },
    setId (id = null) {
      this.form.id = id
    },
    ok () {
      this.mustValidate = this.isCommentValidationRequired
      if (this.isComment) {
        if (this.customValidation.$error) {
          return
        } else {
          this.$emit('ok', this.form)
          this.mustValidate = false
        }
      } else {
        this.$emit('ok')
      }
      this.closeModal()
    },
    cancel () {
      if (this.isComment) {
        this.isComment = false
        this.isCommentValidationRequired = false
        this.form = JSON.parse(this.initialForm)
        this.$emit('cancel')
      } else {
        this.mustValidate = false
        this.$emit('cancel')
      }
      this.closeModal()
    },
    onShow () {
      this.okButtonTitle = this.okTitle || this.$t('Ok')
      this.cancelButtonTitle = this.cancelTitle || this.$t('cancel')
    }
  },
  created () {
    this.initialForm = JSON.stringify(this.form)
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
